import React from 'react';

const stats = [
  { big: '×21', lbl: <>higher conversion when replying within 5 min vs 30 min<br />(MIT / InsideSales)</> },
  { big: '42h', lbl: <>average lead response time across companies<br />(Harvard Business Review)</> },
  { big: '80%', lbl: <>of leads never convert, due to lack of follow-up<br />(Baromètre du Lead 2025)</> },
  { big: '~90%', lbl: <>open rate on Instagram DMs vs 20-30% on email</> }
];

function Stats() {
  return (
    <section id="proof">
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Market data</div>
          <h2>Why speed and follow-up change everything</h2>
          <p>Public data, sources cited. This is the problem Salesyo solves.</p>
        </div>
        <div className="numbers">
          {stats.map((s, i) => (
            <div className="num" key={i}>
              <div className="big">{s.big}</div>
              <div className="lbl">{s.lbl}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
